// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: '5b4ea93',
    builtAt: '2026-06-22T14:29:58.314Z',
} as const;
